import React from 'react';

import NewsletterForm from './newsletter-form';

import SubscribeSymbol from '../../../../images/subscribe-symbol.png';

import '../../../styles/common/promos/newsletter-signup.scss';

const NewsletterSignup = (props) => {
    return (
		<div className="newsletter-signup">
			<div className="wrapper">
				<img src={ SubscribeSymbol } alt="Hand holding envelope" />
				<p className="headline">
					Get Our Newsletter
				</p>
				<p className="message">
					Our latest content, your inbox, every fortnight
				</p>
				<NewsletterForm formLocation={props.formLocation} />
			</div> 
		</div>
    );
}


export default NewsletterSignup;